import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { DataQualityResponse } from '@/types/dataQuality';

export function useDataQualitySummary() {
  return useQuery<DataQualityResponse>({
    queryKey: ['data-quality', 'summary'],
    queryFn: async () => {
      const { data } = await api.get<DataQualityResponse>('/data-quality/summary');
      return data;
    },
    staleTime: 60_000,
  });
}
